import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export interface StrapiMapSectionDTO extends StrapiDynamicZoneComponentDTO {
  latitude: string;
  longitude: string;
  zoom: number;
  showDirections: boolean;
  directions?: string;
  invite?: string;
}

export class MapSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  latitude: string;
  longitude: string;
  zoom: number;
  showDirections: boolean;
  /** condensed transit directions rendered beside the map (P6n) */
  directions?: import("next-mdx-remote").MDXRemoteSerializeResult;
  /** per-page invite line; empty falls back to the map.invite locale string */
  invite?: string;
}
